import * as React from "react";

export const IconCopyEmail = (props: React.SVGProps<SVGSVGElement>): React.JSX.Element => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#clip0_30059_75283)">
      <path
        d="M16 1H4C2.9 1 2 1.9 2 3V17H4V3H16V1ZM15 5L21 11V21C21 22.1 20.1 23 19 23H7.99C6.89 23 6 22.1 6 21L6.01 7C6.01 5.9 6.9 5 8 5H15ZM14 12H19.5L14 6.5V12Z"
        fill="#767B7E"
      />
    </g>
    <defs>
      <clipPath id="clip0_30059_75283">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
